import { createContext } from 'react';
export const DocumentsContext = createContext(null);
export const DocumentsParentContext = createContext(null);
export const FlatDocumentsContext = createContext(null);